import {Observable, SchedulerLike} from 'rxjs';
import {shareReplay} from 'rxjs/operators';

export class CachedReplay<T> {
  private sharedReplay$: Observable<T>;
  private subscriptionTime: number;

  private windowTime: number;
  private bufferSize: number;
  private scheduler?: SchedulerLike;
  private source: Observable<T>;

  sharedReplayTimerRefresh(
    source: Observable<T>, bufferSize: number = 1,
    windowTime: number = 3000000, scheduler?: SchedulerLike): Observable<T> {


    this.windowTime = windowTime;
    this.bufferSize = bufferSize;
    this.scheduler = scheduler;
    this.source = source;

    this.buildShareReplay(source, bufferSize, windowTime, scheduler);

    return this.sharedReplay$;
  }

  invalidate() {
    this.buildShareReplay(this.source, this.bufferSize, this.windowTime, this.scheduler);
  }

  private buildShareReplay(source: Observable<T>,
                           bufferSize: number = 1,
                           windowTime: number = 3000000,
                           scheduler?: SchedulerLike) {
    const currentTime = new Date().getTime();

    if (!this.sharedReplay$ || currentTime - this.subscriptionTime > windowTime) {
      this.sharedReplay$ = source.pipe(shareReplay(
        bufferSize, windowTime, scheduler));
      this.subscriptionTime = currentTime;
    }
  }
}
